import { STORAGE_KEY } from "constants/key";

interface UserType {
  accessToken: string;
  refreshToken: string;
  exp?: number;
  userId?: number;
  storeName?: string;
  identificationName?: string;
  userName?: string;
}

/**
 * save data user to local storage
 * @param {UserType} user api response
 */
export const saveUserStorage = (user: UserType) => {
  localStorage.setItem(STORAGE_KEY.USER, JSON.stringify(user));
};

/**
 * @returns {UserType|null} user token
 */
export const getUserStorage = (): UserType | null => {
  const user = localStorage.getItem(STORAGE_KEY.USER);
  return user ? JSON.parse(user) : null;
};

/**
 * remove user token
 */
export const removeUserStorage = () => {
  localStorage.removeItem(STORAGE_KEY.USER);
};

/**
 * Clear all storage (localStorage and sessionStorage)
 * Used when logout or token expiration
 */
export const clearAllStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
};
